import React from 'react';
import clutteredDesktop from '../assets/clutter-latest-desktop.png';
import clutteredMobile from '../assets/clutter-latest-mobile.png';

export default function ProblemSection() {
  return (
    <section className="problem-section">
      <div className="section-container">
        <div className="section-content">
          <h2 className="section-title">We capture more pictures today than at any other point in history.</h2>
          <p className="section-text">
            But with thousands of images scattered across devices and locked in the cloud, most of these memories fade into a digital abyss. 
            <strong> You miss the opportunity to find that perfect photo when you need it most.</strong>
          </p>
        </div>
        <div className="section-image-wrapper">
          <img 
            src={clutteredDesktop}
            srcSet={`${clutteredMobile} 768w, ${clutteredDesktop} 1920w`}
            sizes="(max-width: 768px) 100vw, 50vw"
            alt="Scattered photos across devices" 
            className="section-image"
          />
        </div>
      </div>
    </section>
  );
}

